/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HospitalizationGetPrintLightPdf$Pdf$Params {

/**
 * filter criteria
 */
  hospitalizationId?: number;

/**
 * filter criteria
 */
  languageCode?: string;

/**
 * filter criteria
 */
  messageId?: number;
}

export function hospitalizationGetPrintLightPdf$Pdf(http: HttpClient, rootUrl: string, params?: HospitalizationGetPrintLightPdf$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationGetPrintLightPdf$Pdf.PATH, 'get');
  if (params) {
    rb.query('hospitalizationId', params.hospitalizationId, {});
    rb.query('languageCode', params.languageCode, {});
    rb.query('messageId', params.messageId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<File>;
    })
  );
}

hospitalizationGetPrintLightPdf$Pdf.PATH = '/v1/Hospitalization/GetPrintLightPDF';
